import { DietDisplay } from './DietDisplay';
import { SurveyDisplay } from './SurveyDisplay';
import { Box, Separator } from '@chakra-ui/react';
import { HStack } from '@ayble-health/dashboard-components';

export const DietAndUserMealDisplay = () => {
  return (
    <HStack mx={6}>
      <Box w={'45%'}>
        <DietDisplay readonly={true} />
      </Box>

      <Separator orientation={'vertical'} height={'100hv'} />

      <Box w={'55%'}>
        <SurveyDisplay />
      </Box>
    </HStack>
  );
};
